/* eslint-disable */
import axios from 'axios'

// Módulo para obtener y modificar datos de usuario en trekksoft 
const baseUrl = process.env.VUE_APP_BASE_API + '/trekksoft/'

const state = {
    trekksoft_data: [],
    activity_data: [],
    trekksoft_client: [],
    trekksoft_secret: []
}

const actions = {
    async syncTrekksoftData({
            commit
        },
        date) {
        await axios
            .get(baseUrl + `remote/sync/?day=${date}`)
            .then(r => r.data)
            .then(trekksoft_data => {
                commit('SET_TREKKSOFT_DATA', trekksoft_data)
            })
    },
    async syncActivityData({
        commit
    }) {
        await axios
            .get(baseUrl + `remote/sync_rules/`)
            .then(r => r.data)
            .then(activity_data => {
                commit('SET_ACTIVITY_DATA', activity_data)
            })
    },
    async getTrekksoftClientName({
        commit
    }) {
        await axios
            .get(baseUrl + `config/?key=client_id`)
            .then(r => r.data)
            .then(trekksoft_data => {
                commit('SET_TREKKSOFT_CLIENT_ID', trekksoft_data)
            })
    },
    getTrekksoftClientPass({
        commit
    }) {
        axios
            .get(baseUrl + `config/?key=client_secret`)
            .then(r => r.data)
            .then(trekksoft_data => {
                commit('SET_TREKKSOFT_CLIENT_SECRET', trekksoft_data)
            })
    },
    changeTrekksoftClientData({
        commit
    }, payload) {
        axios
            .patch(baseUrl + `config/update_key/`, payload)
            .then(r => r.data)
            .then(trekksoft_data => {
                commit('SET_TREKKSOFT_CLIENT_SECRET', trekksoft_data)
            })
    }
}

const mutations = {
    SET_TREKKSOFT_DATA(state, trekksoft_data) {
        state.trekksoft_data = trekksoft_data
    },
    SET_ACTIVITY_DATA(state, activity_data) {
        state.activity_data = activity_data
    },
    SET_TREKKSOFT_CLIENT_ID(state, trekksoft_data) {
        state.trekksoft_client = trekksoft_data[0].value
    },
    SET_TREKKSOFT_CLIENT_SECRET(state, trekksoft_data) {
        state.trekksoft_secret = trekksoft_data
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}